// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__b3NBJ","inner":"Form_inner__3MNxh","range":"Form_range__2C84E","name":"Form_name__1EXZA","actions":"Form_actions__2cJW7"};